<template>
  <div class="container">
    <span class="title">{{ title }}</span>
    <TableSeven
      :distribuccionPersonalL="distribuccionPersonalL"
      :readOnly="readOnly"
    />
    <span class="title">{{ titleOne }}</span>
    <TableOne
      :retroalimentacionDesempenio="retroalimentacionDesempenio"
      :readOnly="readOnly"
    />
  </div>
</template>

<script>
import TableSeven from "./components/mainTableseven/TableSeven";
import TableOne from "./components/mainTableseven/TableOne";

export default {
  props: ["distribuccionPersonalL", "retroalimentacionDesempenio", "readOnly"],
  components: {
    // TableBolean,
    TableSeven,
    TableOne,
  },
  data() {
    return {
      //Primary Table
      title:
        "7.1 Distribución del Personal según los resultados de las Calificaciones",
      //Secondary Table
      titleOne:
        "7.2 Sistema formal de retroalimentación del desempeño implementado",
      textOne: "Tiene sistema de retroalimentación implementado (Sí / No)",
      inputOne: "",
      inputTwo: "",
      inputThree: "",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}

.container {
  margin-bottom: 10px;
}
</style>
